import { getJSON } from 'common/services/api'

export type ChargeReportCsvReportType = 'charge_report' | 'breakdown'

export type DownloadChargeReportCsvParams = {
  startTime: string
  endTime: string
  reportType: ChargeReportCsvReportType
  serviceUserIds?: string[]
  fundingTypeIds?: string[]
  // The home's configured people nominative (e.g. "Client"), used for the
  // aggregate CSV's first-column header. Ignored by the breakdown report.
  serviceUserLabel?: string
  fileName?: string
}

/**
 * Fetches the server-rendered CSV from the rota API and triggers a browser
 * download (mirrors downloadPayReportCsv). The `charge_report` report type is
 * the aggregated list; `breakdown` is a single funder/service-user's visits.
 */
export async function downloadChargeReportCsv({
  startTime,
  endTime,
  reportType,
  serviceUserIds,
  fundingTypeIds,
  serviceUserLabel,
  fileName = 'charge-report.csv'
}: DownloadChargeReportCsvParams): Promise<void> {
  const search = new URLSearchParams()
  search.set('startTime', startTime)
  search.set('endTime', endTime)
  search.set('reportType', reportType)
  serviceUserIds?.forEach((id) => {
    search.append('serviceUserIds[]', id)
  })
  fundingTypeIds?.forEach((id) => {
    search.append('fundingTypeIds[]', id)
  })
  if (serviceUserLabel) {
    search.set('serviceUserLabel', serviceUserLabel)
  }

  const text = (await getJSON({
    url: `charge-reports/csv?${search.toString()}`,
    isRota: true,
    responseType: 'text'
  })) as string

  const blob = new Blob([text], { type: 'text/csv;charset=utf-8' })
  const blobUrl = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = blobUrl
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.URL.revokeObjectURL(blobUrl)
}
